import React, { useState, useEffect } from 'react'
import { Outlet, Link, useLocation } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore.js'
import api from '../services/api'

function Layout() {
  const { user, logout } = useAuthStore()
  const location = useLocation()

  const [settingsOpen, setSettingsOpen] = useState(false)
  const [simpananOpen, setSimpananOpen] = useState(false)
  const [transaksiOpen, setTransaksiOpen] = useState(false)
  const [uangPangkalOpen, setUangPangkalOpen] = useState(false)
  const [pinjamanOpen, setPinjamanOpen] = useState(false)
  const [incidentalLoanOpen, setIncidentalLoanOpen] = useState(false)
  const [serbaUsahaOpen, setSerbaUsahaOpen] = useState(false)
  const [laporanOpen, setLaporanOpen] = useState(false)
  const [cooperativeProfile, setCooperativeProfile] = useState(null)
  const [showChangePassword, setShowChangePassword] = useState(false)
  const [passwordForm, setPasswordForm] = useState({ oldPassword: '', newPassword: '', confirmPassword: '' })
  const [passwordLoading, setPasswordLoading] = useState(false)

  useEffect(() => {
    fetchCooperativeProfile()
  }, [user])

  useEffect(() => {
    setSettingsOpen(location.pathname.startsWith('/settings'))
    setSimpananOpen(location.pathname.startsWith('/savings') || location.pathname.startsWith('/simpanan-berjangka'))
    setTransaksiOpen(location.pathname.startsWith('/members/transaction') || location.pathname.startsWith('/savings/setoran-reguler') || location.pathname.startsWith('/transactions') || location.pathname.startsWith('/uang-pangkal'))
    setPinjamanOpen(location.pathname.startsWith('/loans'))
    setIncidentalLoanOpen(location.pathname.startsWith('/incidental-loans'))
    setSerbaUsahaOpen(location.pathname.startsWith('/serba-usaha'))
    setLaporanOpen(location.pathname.startsWith('/reports') || location.pathname.startsWith('/shu') || location.pathname.startsWith('/members/card'))
  }, [location.pathname])

  const fetchCooperativeProfile = async () => {
    try {
      const response = await api.get('/settings/profile')
      setCooperativeProfile(response.data.data || null)
    } catch (error) {
      console.error('Error fetching cooperative profile:', error)
    }
  }

  const handleLogout = (e) => {
    e.preventDefault()
    logout()
    window.location.href = '/login'
  }

  const handleChangePassword = async (e) => {
    e.preventDefault()
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      alert('Konfirmasi password tidak cocok')
      return
    }
    if (passwordForm.newPassword.length < 6) {
      alert('Password minimal 6 karakter')
      return
    }
    setPasswordLoading(true)
    try {
      await api.put('/auth/change-password', {
        oldPassword: passwordForm.oldPassword,
        newPassword: passwordForm.newPassword
      })
      alert('Password berhasil diubah')
      setShowChangePassword(false)
      setPasswordForm({ oldPassword: '', newPassword: '', confirmPassword: '' })
    } catch (error) {
      alert(error.response?.data?.message || 'Gagal mengubah password')
    } finally {
      setPasswordLoading(false)
    }
  }

  const isActive = (path) => location.pathname.startsWith(path) ? 'active' : ''
  const isExact = (path) => location.pathname === path ? 'active' : ''

  return (
    <div className="wrapper">
      {/* --- HEADER NAVBAR --- */}
      <nav className="main-header navbar navbar-expand navbar-white navbar-light border-bottom shadow-sm">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a className="nav-link" data-widget="pushmenu" href="#" role="button">
              <i className="fas fa-bars"></i>
            </a>
          </li>
          <li className="nav-item d-none d-sm-inline-block">
            <Link to="/" className="nav-link font-weight-bold">Beranda</Link>
          </li>
        </ul>

        <ul className="navbar-nav ml-auto">
          <li className="nav-item dropdown">
            <a className="nav-link" data-toggle="dropdown" href="#">
              <i className="fas fa-user-circle mr-1 text-primary"></i>
              <span className="font-weight-bold">{user?.namaLengkap || user?.username}</span>
            </a>
            <div className="dropdown-menu dropdown-menu-right shadow border-0">
              <a href="#" className="dropdown-item" onClick={(e) => { e.preventDefault(); setShowChangePassword(true) }}>
                <i className="fas fa-key mr-2"></i> Ubah Password
              </a>
              <div className="dropdown-divider"></div>
              <a href="#" className="dropdown-item text-danger" onClick={handleLogout}>
                <i className="fas fa-sign-out-alt mr-2"></i> Logout
              </a>
            </div>
          </li>
        </ul>
      </nav>

      {/* --- SIDEBAR --- */}
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        <a href="/" className="brand-link bg-primary">
          <i className="fas fa-university brand-image mt-1 ml-3"></i>
          <span className="brand-text font-weight-light ml-2">CORE SYSTEM</span>
        </a>

        <div className="sidebar">
          <nav className="mt-3">
            {user?.role === 'member' ? (
              <ul className="nav nav-pills nav-sidebar flex-column" role="menu">
                <li className="nav-item">
                  <Link to="/member/dashboard" className={`nav-link ${isExact('/member/dashboard')}`}>
                    <i className="nav-icon fas fa-tachometer-alt"></i>
                    <p>Dashboard Anggota</p>
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to={`/members/card?nba=${user?.anggotaId || ''}`} className={`nav-link ${isActive('/members/card')}`}>
                    <i className="nav-icon fas fa-id-card"></i>
                    <p>Kartu Simpan Pinjam</p>
                  </Link>
                </li>
              </ul>
            ) : (
              <ul className="nav nav-pills nav-sidebar flex-column nav-child-indent" data-widget="treeview" role="menu">
              {/* Dashboard */}
              <li className="nav-item">
                <Link to="/" className={`nav-link ${isExact('/')}`}>
                  <i className="nav-icon fas fa-tachometer-alt"></i>
                  <p>Dashboard</p>
                </Link>
              </li>

              {/* Data Anggota */}
              <li className="nav-item">
                <Link to="/members" className={`nav-link ${isActive('/members')}`}>
                  <i className="nav-icon fas fa-users"></i>
                  <p>Data Anggota</p>
                </Link>
              </li>

              {/* Transaksi with Submenu */}
              <li className={`nav-item ${transaksiOpen ? 'menu-open' : ''}`}>
                <a href="#" className={`nav-link ${isActive('/members/transaction')}`} onClick={() => setTransaksiOpen(!transaksiOpen)}>
                  <i className="nav-icon fas fa-money-bill-wave"></i>
                  <p>
                    Transaksi
                    <i className="right fas fa-angle-left"></i>
                  </p>
                </a>
                <ul className="nav nav-treeview" style={{ display: transaksiOpen ? 'block' : 'none' }}>
                  <li className="nav-item">
                    <Link to="/members/transaction" className={`nav-link ${isExact('/members/transaction')}`}>
                      <i className="far fa-circle nav-icon"></i>
                      <p>Transaksi Anggota Baru</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/savings/setoran-reguler" className={`nav-link ${isExact('/savings/setoran-reguler')}`}>
                      <i className="far fa-circle nav-icon"></i>
                      <p>Setoran Reguler</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/transactions/jurnal-umum" className={`nav-link ${isExact('/transactions/jurnal-umum')}`}>
                      <i className="far fa-circle nav-icon"></i>
                      <p>Jurnal Umum</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/transactions/penarikan-simpanan" className={`nav-link ${isExact('/transactions/penarikan-simpanan')}`}>
                      <i className="far fa-circle nav-icon"></i>
                      <p>Penarikan Simpanan</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/uang-pangkal" className={`nav-link ${isExact('/uang-pangkal')}`}>
                      <i className="far fa-circle nav-icon"></i>
                      <p>Uang Pangkal</p>
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Simpanan with Submenu */}
              <li className={`nav-item ${simpananOpen ? 'menu-open' : ''}`}>
                <a href="#" className={`nav-link ${isActive('/savings') || isActive('/simpanan-berjangka')}`} onClick={() => setSimpananOpen(!simpananOpen)}>
                  <i className="nav-icon fas fa-piggy-bank"></i>
                  <p>
                    Simpanan
                    <i className="right fas fa-angle-left"></i>
                  </p>
                </a>
                <ul className="nav nav-treeview" style={{ display: simpananOpen ? 'block' : 'none' }}>
                  <li className="nav-item">
                    <Link to="/simpanan-berjangka" className={`nav-link ${isExact('/simpanan-berjangka')}`}>
                      <i className="far fa-circle nav-icon"></i>
                      <p>Simpanan Khusus (Berjangka)</p>
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Pinjaman with Submenu */}
              <li className={`nav-item ${pinjamanOpen ? 'menu-open' : ''}`}>
                <a href="#" className={`nav-link ${isActive('/loans')}`} onClick={() => setPinjamanOpen(!pinjamanOpen)}>
                  <i className="nav-icon fas fa-hand-holding-usd"></i>
                  <p>
                    Pinjaman
                    <i className="right fas fa-angle-left"></i>
                  </p>
                </a>
                <ul className="nav nav-treeview" style={{ display: pinjamanOpen ? 'block' : 'none' }}>
                  <li className="nav-item">
                    <Link to="/loans/reguler" className={`nav-link ${isExact('/loans/reguler')}`}>
                      <i className="far fa-circle nav-icon"></i>
                      <p>Pinjaman Reguler</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/loans/disbursement" className={`nav-link ${isExact('/loans/disbursement')}`}>
                      <i className="far fa-circle nav-icon"></i>
                      <p>Pencairan Pinjaman</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/loans/payment" className={`nav-link ${isExact('/loans/payment')}`}>
                      <i className="far fa-circle nav-icon"></i>
                      <p>Pembayaran Pinjaman</p>
                    </Link>
                  </li>
                  <li className={`nav-item ${incidentalLoanOpen ? 'menu-open' : ''}`}>
                    <a href="#" className={`nav-link ${isActive('/incidental-loans')}`} onClick={() => setIncidentalLoanOpen(!incidentalLoanOpen)}>
                      <i className="far fa-circle nav-icon"></i>
                      <p>
                        Pinjaman Insidentil
                        <i className="right fas fa-angle-left"></i>
                      </p>
                    </a>
                    <ul className="nav nav-treeview" style={{ display: incidentalLoanOpen ? 'block' : 'none' }}>
                      <li className="nav-item">
                        <Link to="/incidental-loans" className={`nav-link ${isExact('/incidental-loans')}`}>
                          <i className="far fa-circle nav-icon"></i>
                          <p>Daftar Pinjaman</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="/incidental-loans/topup" className={`nav-link ${isExact('/incidental-loans/topup')}`}>
                          <i className="far fa-circle nav-icon"></i>
                          <p>Topup Pinjaman</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="/incidental-loans/new" className={`nav-link ${isExact('/incidental-loans/new')}`}>
                          <i className="far fa-circle nav-icon"></i>
                          <p>Pengajuan Pinjaman</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="/incidental-loans/disbursement" className={`nav-link ${isExact('/incidental-loans/disbursement')}`}>
                          <i className="far fa-circle nav-icon"></i>
                          <p>Pencairan Pinjaman</p>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link to="/incidental-loans/payment" className={`nav-link ${isExact('/incidental-loans/payment')}`}>
                          <i className="far fa-circle nav-icon"></i>
                          <p>Pembayaran Pinjaman</p>
                        </Link>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

              {/* Serba Usaha */}
              <li className={`nav-item ${serbaUsahaOpen ? 'menu-open' : ''}`}>
                <a href="#" className={`nav-link ${isActive('/serba-usaha')}`}
                   onClick={() => setSerbaUsahaOpen(!serbaUsahaOpen)}>
                  <i className="nav-icon fas fa-store"></i>
                  <p>
                    Serba Usaha
                    <i className="right fas fa-angle-left"></i>
                  </p>
                </a>
                <ul className="nav nav-treeview" style={{ display: serbaUsahaOpen ? 'block' : 'none' }}>
                  <li className="nav-item">
                    <Link to="/serba-usaha/barang" className={`nav-link ${isExact('/serba-usaha/barang')}`}>
                      <i className="far fa-circle nav-icon"></i><p>Data Barang</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/serba-usaha/transaksi-baru" className={`nav-link ${isExact('/serba-usaha/transaksi-baru')}`}>
                      <i className="far fa-circle nav-icon"></i><p>Transaksi Baru</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/serba-usaha/transaksi" className={`nav-link ${isExact('/serba-usaha/transaksi')}`}>
                      <i className="far fa-circle nav-icon"></i><p>Daftar Transaksi</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/serba-usaha/pembayaran" className={`nav-link ${isExact('/serba-usaha/pembayaran')}`}>
                      <i className="far fa-circle nav-icon"></i><p>Pembayaran Kredit</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/serba-usaha/stok-masuk" className={`nav-link ${isExact('/serba-usaha/stok-masuk')}`}>
                      <i className="far fa-circle nav-icon"></i><p>Stok Masuk</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/serba-usaha/laporan" className={`nav-link ${isExact('/serba-usaha/laporan')}`}>
                      <i className="far fa-circle nav-icon"></i><p>Laporan</p>
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/serba-usaha/pengaturan" className={`nav-link ${isExact('/serba-usaha/pengaturan')}`}>
                      <i className="far fa-circle nav-icon"></i><p>Pengaturan</p>
                    </Link>
                  </li>
                </ul>
              </li>

              {/* Laporan with Submenu */}
              <li className={`nav-item ${laporanOpen ? 'menu-open' : ''}`}>
                <a href="#" className={`nav-link ${isActive('/reports')}`} onClick={() => setLaporanOpen(!laporanOpen)}>
                  <i className="nav-icon fas fa-chart-bar"></i>
                  <p>
                    Laporan
                    <i className="right fas fa-angle-left"></i>
                  </p>
                </a>
                <ul className="nav nav-treeview" style={{ display: laporanOpen ? 'block' : 'none' }}>
                  <li className="nav-item"><Link to="/reports/jurnal" className={`nav-link ${isExact('/reports/jurnal')}`}><i className="far fa-circle nav-icon"></i><p>Jurnal Umum</p></Link></li>
                  <li className="nav-item"><Link to="/reports/buku-besar" className={`nav-link ${isExact('/reports/buku-besar')}`}><i className="far fa-circle nav-icon"></i><p>Buku Besar</p></Link></li>
                  <li className="nav-item"><Link to="/reports/neraca" className={`nav-link ${isExact('/reports/neraca')}`}><i className="far fa-circle nav-icon"></i><p>Neraca (Balance Sheet)</p></Link></li>
                  <li className="nav-item"><Link to="/reports/laba-rugi" className={`nav-link ${isExact('/reports/laba-rugi')}`}><i className="far fa-circle nav-icon"></i><p>Laba Rugi</p></Link></li>
                  <li className="nav-item"><Link to="/reports/cashflow" className={`nav-link ${isExact('/reports/cashflow')}`}><i className="far fa-circle nav-icon"></i><p>Cash Flow</p></Link></li>
                  <li className="nav-item"><Link to="/reports/simpanan" className={`nav-link ${isExact('/reports/simpanan')}`}><i className="far fa-circle nav-icon"></i><p>Laporan Simpanan</p></Link></li>
                  <li className="nav-item"><Link to="/reports/pinjaman" className={`nav-link ${isExact('/reports/pinjaman')}`}><i className="far fa-circle nav-icon"></i><p>Laporan Pinjaman</p></Link></li>
                  <li className="nav-item"><Link to="/reports/keanggotaan" className={`nav-link ${isExact('/reports/keanggotaan')}`}><i className="far fa-circle nav-icon"></i><p>Keanggotaan</p></Link></li>
                  <li className="nav-item"><Link to="/reports/saldo-simpanan" className={`nav-link ${isExact('/reports/saldo-simpanan')}`}><i className="far fa-circle nav-icon"></i><p>Saldo Simpanan</p></Link></li>
                  <li className="nav-item"><Link to="/reports/shu" className={`nav-link ${isExact('/reports/shu')}`}><i className="far fa-circle nav-icon"></i><p>SHU</p></Link></li>
                  <li className="nav-item"><Link to="/shu/calculation" className={`nav-link ${isExact('/shu/calculation')}`}><i className="far fa-circle nav-icon"></i><p>Perhitungan SHU (Lama Mengendap)</p></Link></li>
                  <li className="nav-item"><Link to="/members/card" className={`nav-link ${isExact('/members/card')}`}><i className="far fa-circle nav-icon"></i><p>Kartu Simpan Pinjam</p></Link></li>
                </ul>
              </li>

              {/* Settings with Submenu */}
              <li className={`nav-item ${settingsOpen ? 'menu-open' : ''}`}>
                <a href="#" className={`nav-link ${isActive('/settings')}`} onClick={() => setSettingsOpen(!settingsOpen)}>
                  <i className="nav-icon fas fa-cog"></i>
                  <p>
                    Pengaturan
                    <i className="right fas fa-angle-left"></i>
                  </p>
                </a>
                <ul className="nav nav-treeview" style={{ display: settingsOpen ? 'block' : 'none' }}>
                  <li className="nav-item"><Link to="/settings/profile" className={`nav-link ${isExact('/settings/profile')}`}><i className="far fa-circle nav-icon"></i><p>Profil KSP</p></Link></li>
                  <li className="nav-item"><Link to="/settings/pengurus" className={`nav-link ${isExact('/settings/pengurus')}`}><i className="far fa-circle nav-icon"></i><p>Pengurus</p></Link></li>
                  <li className="nav-item"><Link to="/settings/config" className={`nav-link ${isExact('/settings/config')}`}><i className="far fa-circle nav-icon"></i><p>Setting Dasar</p></Link></li>
                  <li className="nav-item"><Link to="/settings/coa" className={`nav-link ${isExact('/settings/coa')}`}><i className="far fa-circle nav-icon"></i><p>Kode Akun (COA)</p></Link></li>
                  <li className="nav-item"><Link to="/settings/lingkungan" className={`nav-link ${isExact('/settings/lingkungan')}`}><i className="far fa-circle nav-icon"></i><p>Lingkungan / Area</p></Link></li>
                  <li className="nav-item"><Link to="/settings/incidental-loan" className={`nav-link ${isExact('/settings/incidental-loan')}`}><i className="far fa-circle nav-icon"></i><p>Setting Pinjaman Insidentil</p></Link></li>
                  {(user?.role === 'admin' || user?.role === 'manager') && (
                    <li className="nav-item"><Link to="/settings/users" className={`nav-link ${isExact('/settings/users')}`}><i className="far fa-circle nav-icon"></i><p>Manajemen User</p></Link></li>
                  )}
                </ul>
              </li>

            </ul>
            )}
          </nav>
        </div>
      </aside>

      {/* --- MAIN CONTENT --- */}
      <div className="content-wrapper bg-light">
        <div className="content-header bg-white border-bottom mb-4">
          <div className="container-fluid">
            <div className="row align-items-center">
              <div className="col-sm-6">
                <h1 className="m-0 h4 font-weight-bold">
                  {cooperativeProfile?.NamaKoperasi || 'Koperasi SP'}
                </h1>
                <small className="text-muted">Manajemen Keuangan Terintegrasi</small>
              </div>
            </div>
          </div>
        </div>
        
        <section className="content">
          <div className="container-fluid animate__animated animate__fadeIn">
            <Outlet />
          </div>
        </section>
      </div>

      {/* --- CHANGE PASSWORD MODAL --- */}
      {showChangePassword && (
        <div className="modal fade show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header bg-primary text-white">
                <h6 className="modal-title">Ubah Password</h6>
                <button type="button" className="close text-white" onClick={() => setShowChangePassword(false)}>&times;</button>
              </div>
              <form onSubmit={handleChangePassword}>
                <div className="modal-body">
                  <div className="form-group">
                    <label>Password Lama</label>
                    <input type="password" className="form-control" required
                      value={passwordForm.oldPassword}
                      onChange={(e) => setPasswordForm({ ...passwordForm, oldPassword: e.target.value })} />
                  </div>
                  <div className="form-group">
                    <label>Password Baru</label>
                    <input type="password" className="form-control" required minLength="6"
                      value={passwordForm.newPassword}
                      onChange={(e) => setPasswordForm({ ...passwordForm, newPassword: e.target.value })} />
                  </div>
                  <div className="form-group">
                    <label>Konfirmasi Password Baru</label>
                    <input type="password" className="form-control" required
                      value={passwordForm.confirmPassword}
                      onChange={(e) => setPasswordForm({ ...passwordForm, confirmPassword: e.target.value })} />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowChangePassword(false)}>Batal</button>
                  <button type="submit" className="btn btn-primary" disabled={passwordLoading}>
                    {passwordLoading ? 'Menyimpan...' : 'Simpan'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* --- FOOTER --- */}
      <footer className="main-footer small">
        <div className="float-right d-none d-sm-block"><b>Version</b> 1.0.0</div>
        <strong>&copy; 2026 <span className="text-primary">CITRA INTI DATA</span>.</strong>
      </footer>
    </div>
  )
}

export default Layout